import React from 'react'

// material ui
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'

// components
import FlexibilityText from 'components/shared/Cart/FlexibilityText'

const AddDaysHeader = props => {
  return (
    <>
      <Typography my={4} variant='h2' align='center'>
        Add Days
      </Typography>

      <Container>
        <FlexibilityText />
      </Container>
    </>
  )
}

export default AddDaysHeader
